import { render, staticRenderFns } from "./Inactive.vue?vue&type=template&id=1b033788&"
import script from "./Inactive.vue?vue&type=script&lang=js&"
export * from "./Inactive.vue?vue&type=script&lang=js&"
import style0 from "./Inactive.vue?vue&type=style&index=0&id=1b033788&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports